import { phoneBrandsProvider } from './phone-specs-provider'
import { AnswersProvider, AnswersProviders } from './interfaces'
import { Scenario, ScenarioType } from '../state/interfaces'
import { phoneCondensedBrandsProvider } from './phone-specs-condensed-provider'

export const getAnswerProviderByName = (name: AnswersProviders, scenario: Scenario): AnswersProvider => {
  switch (name) {
    case AnswersProviders.PHONES_BRANDS:
      if (scenario.type === ScenarioType.PHONE_SEARCH) {
        return phoneCondensedBrandsProvider
      }
      return phoneBrandsProvider
  }
}
